import { t } from 'Src/i18n';

export const mapColToCard = ({
  color,
  cta,
  displayRatio,
  icon,
  introduction,
  link,
  mediaRatio,
  mediaUrl,
  smallTitle,
  subTitle,
  text,
  title,
}) => {
  return {
    closeLabel: t('common.close'),
    color: color,
    ctaLabel: cta,
    heading: {
      iconName: icon,
      title: title,
      small: smallTitle,
      subtitle: subTitle,
    },
    introduction: {
      text: introduction,
    },
    link: { url: link },
    media: {
      alt: '',
      ratioKey: mediaRatio,
      ratioDisplay: displayRatio,
      url: mediaUrl,
    },
    seeLessLabel: t('common.loadLess'),
    seeMoreLabel: t('common.seeMore'),
    text: {
      text: text,
    },
  };
};
